module.exports = __webpack_public_path__ + "img/check-circle-gray.4831133b.svg";